import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as JobActions, selectors as JobSelectors } from "store/modules/jobs";
import { tabStyles } from "../../styles";
import TableComponent from "../TableComponent";

export default function QueuedTab(props) {
    const classes = tabStyles();
    const dispatch = useDispatch();
    const pageInfo = useSelector(JobSelectors.getQueuedPaginationData)
    const jobListData = useSelector(JobSelectors.getListData({ timeframe: 'queued', part: "data" }))
    const pageFilter = useSelector(JobSelectors.getListData({ timeframe: 'queued', part: "filter" }))
    const pageSort = useSelector(JobSelectors.getListData({ timeframe: 'queued', part: "sort" }))
    const fetchData = useCallback(({ pageSize, pageIndex, filters, sortBy }) => {
        dispatch(JobActions.setQueuedPageSize(pageSize));
        dispatch(JobActions.setQueuedFilter(filters));
        dispatch(JobActions.setQueuedSort(sortBy));
        dispatch(JobActions.fetchQueuedJobs(pageIndex));
    }, []);

    useEffect(() => {
        // dispatch(JobActions.fetchListStats("Queue"));
    }, [])

    return (
        <React.Fragment>
            <div className={classes.contentContainer}>
                <TableComponent
                    pageInfo={pageInfo}
                    jobListData={jobListData}
                    pageFilter={pageFilter}
                    pageSort={pageSort}
                    fetchData={fetchData}
                    history={props.history}
                />
            </div>
        </React.Fragment>

    )
}
